import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../../core/services/auth.service';
import { Injectable } from '@angular/core';
import { DocumentService } from '../home/services/document.service';
import { Incident } from '../../../shared/objects/incident/incident';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OrderDocumentService } from '../order/shared/order-document.service';
import { OrderService } from '../order/shared/order.service';

@Injectable()
export class IncidentService {
  private static shouldUpdate: Subject<void> = new Subject();
  public static shouldUpdate$() { return IncidentService.shouldUpdate.asObservable(); }
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private documentService: DocumentService,
    private orderDocumentService: OrderDocumentService,
    private orderService: OrderService,
  ) {}
  public static updateIncidentList() {
    this.shouldUpdate.next();
  }
  public getIncidents(filters: any): Observable<Incident[]> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.put<Incident[]>(
      `${environment.incidentReportingServiceUrl}/getIncidents`,
      filters,
      { headers },
    );
  }

  public getIncident(id): Observable<Incident> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<Incident>(
      `${environment.incidentReportingServiceUrl}/getIncident/${id}`,
      { headers },
    );
  }

  public updateCorrectiveAction(id, correctiveAction: string) {
    const headers = this.authService.getBearerRequestHeaders();
    const incident = new Incident();
    incident.incidentId = id;
    incident.correctiveAction = correctiveAction;
    return this.httpClient.put(
      `${environment.incidentReportingServiceUrl}/updateCorrective`,
      incident,
      { headers },
    );
  }

  public updatePreventiveAction(id, preventiveAction: string) {
    const headers = this.authService.getBearerRequestHeaders();
    const incident = new Incident();
    incident.incidentId = id;
    incident.preventiveAction = preventiveAction;
    return this.httpClient.put(
      `${environment.incidentReportingServiceUrl}/updatePreventive`,
      incident,
      { headers },
    );
  }

  public updateRootcause(id, rootcause: string) {
    const headers = this.authService.getBearerRequestHeaders();
    const incident = new Incident();
    incident.incidentId = id;
    incident.rootcause = rootcause;
    return this.httpClient.put(
      `${environment.incidentReportingServiceUrl}/updateRootcause`,
      incident,
      { headers },
    );
  }

  setupDetails(incidents: Incident[]): Incident[] {
    incidents.forEach(incident => {
      incident.documentStatus =
        this.orderDocumentService.getOrderDocumentStatus(incident.order);
    });
    return incidents;
  }
}
